@if (open()) {
  <div class="dr-overlay" (click)="onCancel()">
    <div class="dr-dialog" role="dialog" aria-label="Why is this being disregarded?" (click)="$event.stopPropagation()">
      <header class="dr-head">
        <div class="dr-head-text">
          <div class="dr-title">Why is this being disregarded?</div>
          @if (itemLabel()) {
            <div class="dr-subtitle">{{ itemLabel() }}</div>
          }
        </div>
        <button class="dr-close" type="button" (click)="onCancel()" aria-label="Close">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
            stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </header>

      <div class="dr-body">
        <div class="dr-reasons" role="radiogroup" aria-label="Reason">
          @for (reasonOption of reasons; track reasonOption.value) {
            <label class="dr-reason" [class.selected]="selectedReason() === reasonOption.value">
              <input
                type="radio"
                name="disregard-reason"
                [value]="reasonOption.value"
                [checked]="selectedReason() === reasonOption.value"
                (change)="selectedReason.set(reasonOption.value)"
              />
              <span>{{ reasonOption.label }}</span>
            </label>
          }
        </div>

        <label class="dr-note-label" for="disregard-note">
          {{ noteRequired() ? 'Explain why (required)' : 'Add a note (optional)' }}
        </label>
        <textarea
          id="disregard-note"
          class="dr-note"
          rows="3"
          maxlength="2000"
          placeholder="e.g. Checked the hex value — it's #207F86 as in the mockup."
          [value]="note()"
          (input)="note.set($any($event.target).value)"
        ></textarea>
      </div>

      <footer class="dr-foot">
        <button class="dr-btn ghost" type="button" (click)="onCancel()">Cancel</button>
        <button class="dr-btn primary" type="button" [disabled]="!canConfirm()" (click)="onConfirm()">Disregard</button>
      </footer>
    </div>
  </div>
}
